import styled, { css } from 'styled-components';

const truncate = css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const EditableInputGroup = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
`;

export const EditableInput = styled.input<{ $truncate?: boolean }>`
    position: relative;
    display: block;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    max-width: 100%;
    padding: 0;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 1.5;
    color: #334e5c;
    background-color: transparent;
    border: solid transparent;
    border-width: 1px 0;

    &:focus {
        outline: none;
    }

    ${({ $truncate }) => $truncate && truncate}
`;

export const EditableValue = styled.p<{ $truncate?: boolean }>`
    margin: 0;
    cursor: pointer;

    ${({ $truncate }) => $truncate && truncate}
`;

/** The edit button is revealed while the value is hovered, unless it is always shown. */
export const EditButtonWrapper = styled.span<{ $alwaysShow?: boolean }>`
    display: ${({ $alwaysShow }) => ($alwaysShow ? 'inline-block' : 'none')};
    margin-left: 10px;

    :hover > & {
        display: inline-block;
    }
`;
